module.exports = __webpack_public_path__ + "img/cell.078b0a16.png";